const creditRatingStatuses = {
  notFound: 'NOT_FOUND',
  forbidden: 'FORBIDDEN',
};

export { creditRatingStatuses };
